import { render } from "./Contact.view.vue?vue&type=template&id=ab164aac"
import script from "./Contact.view.vue?vue&type=script&lang=js"
export * from "./Contact.view.vue?vue&type=script&lang=js"

import "./Contact.view.vue?vue&type=style&index=0&id=ab164aac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__